(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('investmentIdeasComponent', [
            function() {
                return {
                    restrict: 'E',
                    scope: {
                        name: '@?',
                        url: '@?',
                        data: '='
                    },
                    templateUrl: '/templates/investmentIdeasComponent.html'
                };
            }]);
})();
